import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Title from "./Title";
import {SubmissionsContext} from "../providers/SubmissionsProvider";

const useStyles = makeStyles({
    score: {
        fontSize: "80px",
    },
    depositContext: {
        flex: 1,
    },
});

export default function SubmissionStats() {
    const classes = useStyles();
    const submissions = useContext(SubmissionsContext).submissions;
    let pendingSubmissions = 0;

    for (let k in submissions) {
        let userSubmissions = submissions[k];
        pendingSubmissions+=Object.keys(userSubmissions).length;
    }
    return (
        <React.Fragment>
            <Title>Pending Submissions</Title>
            <Typography component="p" variant="h1" className={classes.score}>
                {pendingSubmissions}
            </Typography>
        </React.Fragment>
    );
}
